export const IDENTITY_API_AUTH_NAMESPACE = 'auth';
